import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { mobileDetect } from 'rp-gui-guide';
import { formatDate } from '../../utils/date';
import { nameToUrl } from '../../utils/url';


const RaceDayLink = ({
    courseName, courseUid, raceDate, children,
}) => {
    if (!courseName || !courseUid || !raceDate) {
        return null;
    }

    const date = formatDate(raceDate, 'Y-MM-DD');
    const name = nameToUrl(courseName);
    const url = mobileDetect.isPhone() ?
        `${date}#${name}` : `${courseUid}/${name}/${date}`;
    return (
        <a
            className="ui-link ui-link_table js-popupLink js-navigate-url"
            href={`/racecards/${url}`}
        >
            { children }
            <Svg
                iconName="right"
                className="ui-icon ui-icon__btn chevronIcon"
                size="XSmall"
            />
        </a>
    );
};

RaceDayLink.propTypes = {
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    raceDate: PropTypes.string,
    children: PropTypes.node,
};

export default RaceDayLink;



// WEBPACK FOOTER //
// ./src/js/shared/links/RaceDayLink.jsx